import PageTitle from "../components/PageTitle.jsx";
import WideSecureLayout from "./WideSecureLayout.jsx";
import UserSettingsLayoutMenu from "../components/settings/menu/UserSettingsLayoutMenu.jsx";
import {useContext} from "react";
import Spinner from "../components/Spinner.jsx";
import {useRequireLoginEffect} from "../components/auth/useRequireLoginEffect.js";
import {useTranslation} from "react-i18next";
import {GlobalContext} from "../utils/context/GlobalContextProvider.jsx";

export default function UserSettingsLayout({title, children, actions}) {
    const {context} = useContext(GlobalContext);

    let {t} = useTranslation();

    useRequireLoginEffect();

    return (
        <WideSecureLayout title={t('user.account-settings')}>

            <div className="w-full max-w-9xl mx-auto">

                {/* Content */}
                <div className="comp__roundedBox bg-white dark:bg-slate-800 shadow-lg rounded-sm mb-8">
                    <div className="flex flex-col md:flex-row md:-mr-px">
                        <UserSettingsLayoutMenu/>
                        <div className="grow p-6">
                            <div className={'flex justify-between mb-4'}>
                                {title &&<PageTitle>{title}</PageTitle>}
                                <div>{actions ?? null}</div>
                            </div>
                            <div className="gap-6">
                                {context.currentIdentity === null ? <Spinner/> : children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </WideSecureLayout>
    );
}
